export default {"src":"/developer/_next/static/media/cancel.c300ebf2.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};